const stylesLandingPage = {
  color_phacil: '#513af2',
  color_title: '#161c2d',
  color_text: '#71748d'
}

export { stylesLandingPage }
